<template>
    <tr>
        <td>{{ startedAt }}</td>
        <td><span class="ellipsis"><b>{{ name }}</b> <small>({{ gender }}/{{ birth }})</small></span></td>
        <td><span class="label lgray">{{ isFirstVisit }}</span></td>
        <td><span class="ellipsis">{{ groupTitle }}</span></td>
        <td><span class="ellipsis">{{ columnTitle }}</span></td>
        <td><span class="ellipsis">{{ programTitle }}</span></td>
        <td><span class="ellipsis"><span class="color_circle" :style="circleStyle"></span>{{ statusTitle }}</span></td>
    </tr>
</template>


<script>
import { formatGenderShort } from '@/util/format-gender'
import { toBirth6String } from '@/util/format-birth'
import { sheetState } from '../../../../sheet-state'
import { monitorState } from '../monitor-popup-state'

const moment = require('@/util/MPMoment')

export default {
    props: {
        reservation: Object
    },
    data() {
        return {
            sheetState,
            monitor: monitorState,
        }
    },
    computed: {
        selectedPeriodType: function() {
            return this.monitor.selectedPeriod.periodType
        },
        startedAt: function() {
            return moment(this.reservation.startedAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
        },
        name: function() {
            return this.reservation.userName
        },
        gender: function() {
            return formatGenderShort(this.reservation.hserviceID?.gender) ?? '-'
        },
        birth: function() {
            return toBirth6String(this.reservation.hserviceID?.birth) ?? '-'
        },
        isFirstVisit: function() {
            return this.reservation.isFirstVisit == true 
            ? this.$t('reservationwindow.reservationmonitor.table_outpatient_initialvisit')
            : this.$t('reservationwindow.reservationmonitor.table_outpatient_returnvisit')
        },
        groupTitle: function() {
            return this.reservation.groupTitle ?? '-'
        },
        columnTitle: function() {
            return this.reservation.columnTitle ?? '-'
        },
        programTitle: function() {
            return this.reservation.programTitle ?? '-'
        },
        statusTitle: function() {
            return this.reservation.statusTitle ?? '-'
        },
        circleStyle: function() {
            return 'background-color: ' + this.circleColor
        },

        palette: function() {
            let setting = this.sheetState.reservationSetting
            return setting?.statusColorPaletteID.basicPalette
        },
        circleColor: function() {
            let paletteIndex = this.reservation.statusID?.paletteIndex ?? 0
            return this.palette[paletteIndex]
        }
    }
}
</script>